// extracted by mini-css-extract-plugin
module.exports = {"form":"MealItemForm_form__2cyBQ"};